import { BarCodeIcon } from "@/components/icons/bar-code-icon";
import { CoffeeIcon } from "@/components/icons/coffee-icon";
import { FavouritesIcon } from "@/components/icons/favourites-icon";
import { HeartIcon } from "@/components/icons/heart-icon";
import { HouseIcon } from "@/components/icons/house-icon";
import { RunningIcon } from "@/components/icons/running-icon";
import { SoupIcon } from "@/components/icons/soup-icon";
import { cn } from "@/utils/cn";

export const getMainFilterIcon = (value: string, className?: string) => {
  switch (value) {
    case "recipes":
      return <SoupIcon className={cn("h-6 w-6 fill-white", className)} />;
    case "branded":
      return <BarCodeIcon className={cn("h-6 w-6 fill-white", className)} />;
    case "outAndAbout":
      return <CoffeeIcon className={cn("h-6 w-6 fill-white", className)} />;
    default:
      return null;
  }
};

export const getSubFilterIcon = (value: string, className?: string) => {
  switch (value) {
    case "myFoods":
    case "yourFoods":
      return <FavouritesIcon className={cn("h-6 w-6 fill-white", className)} />;
    case "likedFoods":
    case "myFavourites":
      return <HeartIcon className={cn("h-6 w-6 fill-white", className)} />;
    case "atHome":
      return <HouseIcon className={cn("h-6 w-6 fill-white", className)} />;
    case "onTheGo":
      return <RunningIcon className={cn("h-6 w-6 fill-white", className)} />;
    default:
      return null;
  }
};
